// extracted by mini-css-extract-plugin
module.exports = {"desktopLogo":"desktopLogo__RQLPK","mobileLogo":"mobileLogo__sSkdG"};